<!--设备型号-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">设备型号</span>
      </div>
    </div>
    <div class="content-header">
      <div class="left">
        <Input v-model="value" placeholder="根据条件搜索" @on-enter="getData">
          <Select v-model="key" slot="prepend" style="width:80px">
            <Option value="id">编号</Option>
            <Option value="name">型号</Option>
            <Option value="brand">品牌</Option>
          </Select>
          <Button slot="append" icon="ios-search" @click="getData"></Button>
        </Input>
        <Button style="margin: 2px 0 0 5px" @click="reset">重置</Button>
      </div>
      <div class="right">
        <!-- <Select v-model="is_del" style="width: 100px;margin-right: 5px">
          <Option :value="0" style="text-align:center">型号列表</Option>
          <Option :value="1" style="text-align:center">禁用列表</Option>
        </Select> -->
        <Button style="margin: 0 5px 0 0" @click="exportData">导出Excel</Button>
        <Button type="primary" @click="current = {};visible = true">新增设备型号</Button>
      </div>
    </div>
    <Table style="margin:auto" :columns="columns" :data="data"/>
    <Modal v-model="visible" :title="current.id?'修改设备型号':'新增设备型号'" @on-cancel="visible = false">
      <Form ref="formInline" :model="current" :rules="rule" :label-width="80">
        <FormItem prop="name" label="型号:">
          <Input v-model="current.name" placeholder="设备型号"/>
        </FormItem>
        <FormItem prop="brand" label="品牌:">
          <Input v-model="current.brand" placeholder="设备品牌"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button size="large" @click="visible = false;">取消</Button>
        <Button type="primary" size="large" @click="modalOk" :loading="modalLoading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
export default {
  data () {
    return {
      rule: {
        name: [{required: true, message: '型号必填', trigger: 'blur'}],
        brand: [{required: true, message: '品牌必填', trigger: 'blur'}]
      },
      columns: [
        { title: '编号', width: 100, key: 'id' },
        { title: '型号', key: 'name' },
        { title: '品牌', key: 'brand' },
        { title: '操作',
          width: 150,
          key: 'operator',
          render: (h, data) => {
            return h('div', {}, [
              h('Button', { style: { marginRight: '5px' },
                props: { size: 'small', type: data.row.is_del ? 'success' : 'error' },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: data.row.is_del ? '恢复' : '删除',
                      content: `是否${data.row.is_del ? '恢复' : '删除'}该设备型号(${data.row.name})?`,
                      closable: true,
                      loading: this.loading,
                      onOk: () => {
                        this.loading = true
                        this.current = JSON.parse(JSON.stringify(data.row))
                        this.isDelType()
                      }
                    })
                  }
                } }, data.row.is_del ? '恢复' : '删除'),
              h('Button', { props: { size: 'small', type: 'warning' },
                on: {
                  click: () => {
                    this.current = JSON.parse(JSON.stringify(data.row))
                    this.visible = true
                  }
                } }, '修改')
            ])
          } }
      ],
      data: [],
      current: {},
      visible: false,
      is_del: 0, // 显示回收站
      loading: false, // 确认框loading
      modalLoading: false, // 模态框确定loading
      key: 'id',
      value: ''
    }
  },
  methods: {
    // 导出数据
    exportData () {
      let params = {
        title: ['编号', '型号', '品牌'],
        key: ['id', 'name', 'brand'],
        data: this.data,
        autoWidth: true,
        filename: '设备型号列表'
      }
      excel.export_array_to_excel(params)
    },
    // 重置
    reset () {
      this.key = 'id'
      this.value = ''
      this.getData()
    },
    isDelType () {
      this.current.is_del = this.current.is_del ? 0 : 1
      let temp = JSON.parse(JSON.stringify(this.current));
      delete temp._index;
      delete temp._rowKey;
      this[this.current.is_del?'DelType':'updateType'](temp).then(res => {
        if(res){
          this.$Message.success("操作成功")
          this.getData(this.is_del)
          this.loading = false
          setTimeout(() => {
            this.$Modal.remove();
          }, 500);
        }else{
          this.loading = false
          this.$Message.error("无法删除已使用型号")
        }
      })
    },
    modalOk () {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          this.modalLoading = true
          this[this.current.id ? 'updateType' : 'insertType'](this.current).then(res => {
            this.modalLoading = false
            if (!this.current.id) {
              if(res){
                this.$Message.success('操作成功')
                this.visible = false
                this.current.id = res
                this.data = [this.current].concat(this.data)
              }else{
                this.$Message.error("该品牌下已有同样的型号")
              }
            } else {
              if(res){
                this.$Message.success('操作成功')
                this.visible = false
                this.getData();
              }else{
                this.$Message.error("该品牌下已有同样的型号")
              }

              this.data.map((item, index) => {
                if (item.id === this.current.id) {
                  this.data.splice(index, 1, this.current)
                }
              })
            }
          })
        }
      })
    },
    getData (is_del) {
      is_del = is_del || 0
      this.getType({ cond: this.key, value: this.value, is_del: is_del }).then(res => {
        this.data = res
      })
    },
    ...mapActions(['getType', 'insertType', 'updateType', 'DelType'])
  },
  mounted () {
    this.getData()
  },
  computed: mapGetters({

  }),
  watch: {
    is_del (n, o) {
      this.getData(n)
    }
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
